import { IPrice } from 'app/services/api5-service/api.interface';

import { PriceUi } from './model';

/**
 * Check that there is only cost data to display. Used in list vertical align
 *
 * @param data - price data
 */
export function isOnlyCostDisplayed(data: PriceUi): boolean {
  return !data.discountDataUi && !data.taxDataUi && !data.paymentInfoDataUi;
}

/**
 * Get cost data in one line to track changes
 *
 * @param data - price data
 */
export function getTrackBy(data: IPrice): string {
  return [
    data.cost.$,
    data.currency.$,
    data.discount?.$,
    data.no_discount_cost?.$,
    data.prorata_date?.$,
    data.prorata_hint?.$,
    data.period?.$,
    data.period_cost?.$,
    data.trial?.$,
    data.price_after_trial?.$,
    data.price_after_trial_noautoprolong?.$,
    data.price_after_trial_period?.$,
    data.$special_price,
    data.tax_amount?.$,
    data.tax_exclusive?.$,
  ]
    .filter(Boolean)
    .join('');
}
